import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

interface typeProps {
  name: string;
  label: string;
  placeholder: string;
  data: any;
  setData: Function;
  required?: boolean;
}

/**
 * Editor de texto das etapas.
 *
 * ⚠️ O conteúdo é controlado por estado LOCAL, de propósito. Antes o ReactQuill
 * era ligado direto ao estado do pai (`value={data}` + `onChange={setData}`), e
 * isso derrubava a tela com "Maximum update depth exceeded" (React #185):
 *
 *   1. o Quill NORMALIZA o HTML ao montar (mexe em `<p>&nbsp;</p>`, `<br>`,
 *      `<h3>`, atributos…);
 *   2. se o texto gravado difere do que ele produz, dispara `onChange` sozinho
 *      com a versão normalizada;
 *   3. o pai re-renderiza e devolve o HTML ORIGINAL em `value`;
 *   4. o Quill normaliza de novo → volta ao passo 2, para sempre.
 *
 * A tela ficava branca sem erro no console além do #185 minificado, e só em
 * ALGUNS processos — os que tinham justamente o HTML que o Quill reescreve.
 * Relato colado de outro editor cai nesse caso com facilidade.
 *
 * A guarda compara o `data` recebido com o ÚLTIMO `data` visto — e não com o
 * texto local. É o que fecha o caso em que o pai não persiste a mudança: ali o
 * `data` continua sendo o HTML original para sempre, e comparar com o local
 * reaplicaria o original a cada eco, reiniciando o ciclo.
 */
const TextareaEditor = ({
  name,
  label,
  placeholder,
  data,
  setData,
  required
}: typeProps) => {

  const [valor, setValor] = useState<string>(data || '');
  const ultimoExterno = useRef<string>(data || '');

  useEffect(() => {
    const externo = data || '';
    // Valor de fora só entra quando MUDOU de fato — troca de O.S., de
    // entrevistado, ou texto vindo da transcrição do áudio. Enquanto o `data`
    // continuar o mesmo, nada é reaplicado, e o ciclo não tem como recomeçar.
    if (externo !== ultimoExterno.current) {
      ultimoExterno.current = externo;
      if (externo !== valor) setValor(externo);
    }
  }, [data]); // eslint-disable-line

  const alterar = (value: string) => {
    setValor(value);
    setData(value);
  };

  return (
    <div className="field">
      <label htmlFor="label">{label}:</label>
      <ReactQuill
        id={name}
        value={valor}
        onChange={alterar}
        placeholder={placeholder}
      />

    </div>
  );

};

export default TextareaEditor;
